import { normalizeOwnerDisplayName, ownerKey } from './nameNormalization';

/** Visible Jason going forward (jason@volocean.com). Auth cannot merge his other logins. */
export const CANONICAL_JASON_HOLDSWORTH_UID = 'o51jbQaJGnNwk497grXTlgMvkk02';

/** Every known Jason Holdsworth Firebase UID. Keep Auth; treat as one person in UI. */
export const JASON_HOLDSWORTH_UIDS: ReadonlySet<string> = new Set([
  CANONICAL_JASON_HOLDSWORTH_UID,
  'S8URoumqJwSzAgdjfg6gRne8Zwa2', // jason@voluntas.group
  'n3qiQz9SOzd7pJzbRWa0f2DVPIJ2', // jason@voluntas.co.nz
  'bQk5lx7cLPNxPHrSBKuQvWYc7483', // jason@holdsworth.co.nz (viewer; may still own history)
]);

/** Canonical owner UID when duplicate Firebase accounts share a display name. */
export const PREFERRED_OWNER_UID_BY_NORMALIZED_NAME: Readonly<Record<string, string>> = {
  'jason holdsworth': CANONICAL_JASON_HOLDSWORTH_UID,
};

/**
 * One seed per person. Jason's extra accounts and "Jason Holdsworth" labels
 * collapse to the volocean UID. Jason Ming and everyone else stay distinct.
 */
export function resolveCanonicalOwnerUid(
  uid?: string | null,
  name?: string | null
): string {
  const trimmedUid = (uid || '').trim();
  const normalizedName = normalizeOwnerDisplayName(name || '');
  const preferredFromName = PREFERRED_OWNER_UID_BY_NORMALIZED_NAME[ownerKey(normalizedName)];
  if (preferredFromName) return preferredFromName;
  if (trimmedUid && JASON_HOLDSWORTH_UIDS.has(trimmedUid)) {
    return CANONICAL_JASON_HOLDSWORTH_UID;
  }
  return trimmedUid || normalizedName;
}

export function ownerIdentitiesMatch(
  selectedUid?: string | null,
  rowUid?: string | null,
  rowName?: string | null
): boolean {
  const selected = (selectedUid || '').trim();
  if (!selected) return true;
  const left = resolveCanonicalOwnerUid(selected);
  const right = resolveCanonicalOwnerUid(rowUid, rowName);
  return Boolean(left) && left === right;
}
